import { authClient } from "./components/auth-client";
import { signinSchema } from "../utils/schemas/escrita";

const form = document.querySelector("#signin-form") as HTMLFormElement | null;
const btn = document.querySelector("#submit-btn") as HTMLButtonElement | null;
const msg = document.querySelector("#signin-msg") as HTMLDivElement | null;

let submitting: boolean = false;

if (form) {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    if (submitting) return;

    submitting = true;

    if (msg) {
      msg.innerText = "";
      msg.className = "";
    }
    if (btn) {
      btn.disabled = true;
    }

    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());

    // 1. Validação Antecipada com Zod (Telefone + Senha)
    const result = signinSchema.safeParse(data);

    if (!result.success) {
      if (msg) {
        msg.innerText = result.error.issues
          .map((issue) => issue.message)
          .join("\n");
        msg.className = "error";
      }

      submitting = false;

      if (btn) btn.disabled = false;

      return;
    }

    //Daqui em diante o Zod aceitou

    // 2. Autenticação com Telefone no Better Auth (Timeout 15s)
    try {
      await authClient.signIn.phoneNumber(
        {
          phoneNumber: result.data.phoneNumber,
          password: result.data.password,
        },
        {
          timeout: 15000,

          onRequest: (_ctx) => {
            if (msg) {
              msg.innerText = "Validando credenciais...";
              msg.className = "processing";
            }
          },
          onSuccess: (ctx) => {
            const user = ctx.data.user; // O Better Auth retorna os dados do usuário aqui
            if (msg) {
              msg.innerText = `Bem-vindo, ${user.name || "usuário"}! Redirecionando...`;
              msg.className = "success";
            }
            // Redireciona conforme o perfil
            if (user.role === "admin") {
              window.location.href = "/admin/dashboard";
            } else {
              window.location.href = "/user/dashboard";
            }
          },
          onError: (ctx) => {
            //erros vindos do servidor
            if (msg) {
              msg.innerText = ctx.error.message || "Credenciais inválidas.";
              msg.className = "error";
            }
          },
        },
      );
    } catch (err: unknown) {
      if (err instanceof Error) {
        if (err.name === "AbortError") {
          if (msg) {
            msg.innerText =
              "O servidor demorou muito para responder. Tente novamente.";
            msg.className = "error";
          }
        } else if (err.name === "TypeError") {
          if (msg) {
            msg.innerText =
              "Não foi possível conectar ao servidor. Tente novamente.";
            msg.className = "error";
          }
        } else {
          console.error("Erro inesperado:", err);

          if (msg) {
            msg.innerText =
              "Não foi possível concluir o login. Tente novamente.";
            msg.className = "error";
          }
        }
      }
    } finally {
      if (btn) btn.disabled = false;
      submitting = false;
    }
  });
}

window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    form?.reset();

    if (msg) {
      msg.innerText = "";
      msg.className = "";
    }

    if (btn) {
      btn.disabled = false;
    }

    submitting = false;
  }
});
